'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive DropdownMenu
 * ROLE: menu | ARIA: aria-haspopup="menu", aria-expanded on trigger; menuitem roles on items
 * KEYBOARD: ESC closes; ArrowUp/ArrowDown navigate items; Enter/Space select; Home/End jump edges
 * FOCUS: enters first item on open; type-ahead supported; restores to trigger on close
 * LIVE-REGION: none
 * PRM: animation disabled; opacity instant
 * FORCED-COLORS: content border = ButtonText; destructive item = LinkText
 * RTL: sub-menu direction-aware via Radix
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/menu/
 * SUBSTRATE: @radix-ui/react-dropdown-menu
 */
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import styles from '../_internal/menu.module.css';
export function DropdownMenu({ trigger, children, open, onOpenChange, align = 'start', side = 'bottom', sideOffset = 6, onCloseAutoFocus, }) {
    return (_jsxs(RadixDropdownMenu.Root, { open: open, onOpenChange: onOpenChange, children: [_jsx(RadixDropdownMenu.Trigger, { asChild: true, children: trigger }), _jsx(RadixDropdownMenu.Portal, { children: _jsx(RadixDropdownMenu.Content, { className: styles.content, align: align, side: side, sideOffset: sideOffset, ...(onCloseAutoFocus !== undefined ? { onCloseAutoFocus } : {}), children: children }) })] }));
}
export function DropdownMenuItem({ onSelect, destructive = false, disabled = false, children }) {
    return (_jsx(RadixDropdownMenu.Item, { className: destructive ? styles.itemDestructive : styles.item, onSelect: onSelect, disabled: disabled, children: children }));
}
export function DropdownMenuSeparator(_) {
    return _jsx(RadixDropdownMenu.Separator, { className: styles.separator });
}
export function DropdownMenuLabel({ children }) {
    return _jsx(RadixDropdownMenu.Label, { className: styles.label, children: children });
}
//# sourceMappingURL=DropdownMenu.js.map